import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { adminService } from '@/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadMelatiCsv',
  setup(__props) {

async function download() {
  const indexes = await adminService.getAllMessageIndexes();

  let csv = `Titel,Tekst,Van,Thema's,Aangemaakt,ID\n`;

  csv += indexes
    .map(index => {
      return `${sanitize(index.title)},${sanitize(index.text ?? '')},${sanitize(index.from ?? '')},${
        index.tags?.map(tag => tag.title).join(' | ') ?? ''
      },${index.created},${index.id}`;
    })
    .join('\n');

  downloadCsv(csv);
}

function downloadCsv(csv: string) {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const filename = `indischmonument-melati-export-${new Date().toLocaleDateString().replace(/\//g, '-')}.csv`;

  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function sanitize(str: string) {
  return `"${str.trim()}"`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "outline-btn",
    onClick: download
  }, "Download CSV"))
}
}

})